import { CustomRulesTargetsWebComponent } from './component/CustomRulesTargetsWebComponent';

export { CustomRulesTargetsWebComponent };
